import { BackendSmartAccount, SmartAccountRole } from '~/types'

export const isAutomationAccount = (
  smartAccount?: BackendSmartAccount,
): boolean => {
  if (!smartAccount || smartAccount.isPublicSmartAccount) return false
  return smartAccount.role === SmartAccountRole.AUTOMATION
}
